import { computed, defineComponent, onMounted } from 'vue';
import LanguageSelector from './languageselector.vue';
import { useRouter } from 'vue-router';
import { useI18n } from '@/i18n-shim'
import {store } from '@/store';
import { ensureUser, userStore } from '@/userStore';
import useEsignCommon from '@/eSign-i18n';

export default defineComponent({
  components: {
    LanguageSelector
  },
  props: {
    showLanguageSelector: { type: Boolean, default: false },
    showInfoButton: { type: Boolean, default: false },
    tenantId: { type: String, required: true },
  },
  setup(props, context) {
    const i18n = useI18n();

    onMounted(async () => {
      await ensureUser(props.tenantId);
    });

    const getLogoLanguage = computed(() => `logo-${i18n.locale.value}`);

    const router = useRouter();
    const eSignCommon = useEsignCommon();
    
    const getUserName = computed(() => userStore.loginInfo.displayName);

    const showLogoutButton = computed(() => !!userStore.loginInfo.displayName);
    const loginUrl = computed(() => userStore.loginInfo.loginUrl);

    return {
      availableLanguages: eSignCommon.availableLanguages,
      getLogoLanguage,
      getUserName,
      showLogoutButton,
      logout: () => {
        router.push({name: 'logout', params: { tenantId: props.tenantId }, query: { loginUrl: loginUrl.value }});
      },
      environmentName: store.environmentName,
      ...i18n
    };
  }
});
